import { render, staticRenderFns } from "./ProductQuickView.vue?vue&type=template&id=e675ba5a&"
import script from "./ProductQuickView.vue?vue&type=script&lang=js&"
export * from "./ProductQuickView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports